// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-container input{margin-top:6px!important;outline:none!important}.class-info-container{width:100%;height:100px}.class-info{width:100%;height:100%;display:flex;flex-flow:row;justify-content:center;align-items:center;padding:5px 24px 0 24px}.class-info p{margin-bottom:0!important;line-height:24px;color:rgba(0,0,0,.64)}.class-info p,.class-info span{font-size:16px}canvas:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
